import { z } from "@/zod";
import { nonNegativeDecimalStringSchema } from "@/schemas/commonFields";
import { PROJECT_STATUS } from "@/schemas/project";

export const PERIOD_STATUS_ACTIVE = "active";
export const PERIOD_STATUS_APPROVED = "approved";
export const PERIOD_STATUS_REJECTED = "rejected";
export const PERIOD_STATUS_CLOSED = "closed";

export const PERIOD_STATUS = [
  PERIOD_STATUS_ACTIVE,
  PERIOD_STATUS_APPROVED,
  PERIOD_STATUS_REJECTED,
  PERIOD_STATUS_CLOSED,
] as const;

export const projectSettlement = z.object({
  id: z.string().length(26),
  period: z.string(),
  project_id: z.string().length(26),
  project_ref_number: z.string().nullable(),
  project_crs_number: z.string().nullable(),
  project_name: z.string(),
  client_id: z.string().length(26),
  client_name: z.string(),
  client_tax_number: z.string().nullable(),
  project_start_date: z.string().date(),
  project_end_date: z.string().date(),
  project_type: z.string(),
  project_status: z.enum(PROJECT_STATUS),
  primary_manager: z.string(),
  primary_manager_id: z.string().length(26),
  period_status: z.enum(PERIOD_STATUS),

  planned_hours: nonNegativeDecimalStringSchema,
  planned_avg_rate: nonNegativeDecimalStringSchema,
  planned_income: nonNegativeDecimalStringSchema,

  scheduled_hours: nonNegativeDecimalStringSchema,
  scheduled_avg_rate: nonNegativeDecimalStringSchema,
  scheduled_payment: nonNegativeDecimalStringSchema,

  planned_profitability: nonNegativeDecimalStringSchema,

  contractors_hours: nonNegativeDecimalStringSchema,
  contractors_avg_rate: nonNegativeDecimalStringSchema,
  contractors_payment: nonNegativeDecimalStringSchema,

  invoiced_hours: nonNegativeDecimalStringSchema,
  invoiced_avg_rate: nonNegativeDecimalStringSchema,
  invoiced_income: nonNegativeDecimalStringSchema,

  profitability: nonNegativeDecimalStringSchema,
});

export const projectSettlementsRead = projectSettlement
  .omit({
    client_id: true,
  })
  .readonly();
export type ReadProjectSettlements = z.infer<typeof projectSettlementsRead>;
